export function getAlertDetails(sessionType, trigger = null, shareType, context = {}) {
    const red = '#D32F2F';
    const green = '#388E3C';
    const black = '#1A1A1A';

    if (!sessionType) {
        return { message: "Session en cours de préparation...", color: black };
    }

    const appType = String(context.appType || '').toLowerCase();
    const isChild = appType.includes('enfant') || appType.includes('child');
    const activityType = String(context.activityType || '').toUpperCase();
    const shortcutMode = String(context.shortcutDetectionMode || '').toUpperCase();
    // Sortie Sport (randonnée, course à pied) : nommée par son activité plutôt que suivi / itinéraire.
    const travelMode = String(context.travelMode || '').toUpperCase();
    const sportActivity = travelMode === 'HIKE' ? 'sa randonnée' : travelMode === 'RUN' ? 'sa course à pied' : travelMode === 'MEETING' ? 'son événement' : null;
    // Parcours chargé : son nom (porté par le nom de destination de la session).
    const trailName = String(context.trailName || '').trim();
    const sportLabel = sportActivity && trailName ? `${sportActivity} « ${trailName} »` : sportActivity;

    // Si on est explicitement en mode ALERTE, on vérifie le trigger
    if (sessionType === 'ALERT' || sessionType === 'LIVEMAPALERTE') {
        switch (trigger) {
            case 'WIDGET':
                if (isChild) return { message: "⚠️ L'enfant a envoyé un SOS depuis le widget", color: red };
                return { message: "⚠️ L'utilisateur a déclenché une alerte depuis le widget", color: red };
            case 'MANUAL':
                if (isChild) return { message: "⚠️ L'enfant a envoyé un SOS via l'application", color: red };
                return { message: "⚠️ L'utilisateur a déclenché une alerte depuis l'interface de l'application", color: red };
            case 'SHORTCUT':
                if (shortcutMode === 'POWER') {
                    return { message: `⚠️ ${isChild ? "L'enfant" : "L'utilisateur"} a déclenché une alerte avec le bouton Power`, color: red };
                }
                return { message: `⚠️ ${isChild ? "L'enfant" : "L'utilisateur"} a déclenché une alerte avec les touches Volume`, color: red };
            case 'SHAKE_DETECTED':
                if (isChild) return { message: "⚠️ L'enfant a déclenché une alerte en secouant le téléphone", color: red };
                return { message: "⚠️ L'utilisateur a déclenché une alerte en secouant le téléphone", color: red };
            case 'ITINERARY_STOPPED':
            case 'LIVE_SHARE_STOPPED':
                if (isChild) return { message: "⚠️ L'enfant est arrêté depuis trop longtemps", color: red };
                return { message: "⚠️ L'utilisateur est arrêté depuis trop longtemps", color: red };
            case 'ITINERARY_OUT_OF_ZONE':
                if (isChild && activityType === 'ZONE') return { message: "⚠️ L'enfant est sorti de la zone de jeux", color: red };
                if (isChild && activityType === 'ITINERARY') return { message: "⚠️ L'enfant est sorti de l'itinéraire", color: red };
                return { message: "⚠️ L'utilisateur est sorti de sa zone de sécurité", color: red };
            case 'ACCIDENT_DETECTED':
                if (isChild) return { message: "⚠️ Un potentiel accident de l'enfant a été détecté", color: red };
                return { message: "⚠️ Un potentiel accident de l'utilisateur a été détecté", color: red };
            case 'WATCH':
                return { message: `⚠️ ${isChild ? "L'enfant" : "L'utilisateur"} a déclenché une alerte depuis sa montre`, color: red };
            case 'AGENDA_MISMATCH':
                return { message: `⚠️ ${isChild ? "L'enfant ne se trouve pas au lieu prévu" : "L'utilisateur ne se trouve pas au lieu prévu"}`, color: red };
            case 'AGENDA_UNVERIFIED':
                return { message: `⚠️ La présence de ${isChild ? "l'enfant" : "l'utilisateur"} au lieu prévu n'a pas pu être vérifiée`, color: red };
            default:
                // Fallback si le trigger est null ou inconnu
                return { message: `⚠️ ${isChild ? "L'enfant" : "L'utilisateur"} a déclenché une alerte`, color: red };
        }
    }

    // Modes réguliers (Partage, Itinéraire, etc)
    if (sportLabel && ['SHARE', 'FOLLOW', 'LIVE_SHARE', 'LIVEMAPFOLLOW', 'ITINERARY_SHARED', 'ITINERARY', 'LIVEMAPITINERARY'].includes(sessionType)) {
        return { message: `✅ L'utilisateur partage ${sportLabel} avec vous`, color: green };
    }
    switch (sessionType) {
        case 'SHARE':
            if (shareType === 'ITINERARY') {
                return { message: "✅ L'utilisateur partage son itinéraire avec vous", color: green };
            }
            else
                return { message: "✅ L'utilisateur partage sa position avec vous", color: green };
        case 'FOLLOW':
        case 'LIVE_SHARE':
        case 'LIVEMAPFOLLOW':
            return { message: "✅ L'utilisateur partage sa position avec vous", color: green };
        case 'ITINERARY_SHARED':
        case 'ITINERARY':
        case 'LIVEMAPITINERARY':
            return { message: "✅ L'utilisateur partage son itinéraire avec vous", color: green };
        default:
            return { message: null, color: 'transparent' };
    }
}
